import { api, setToken } from "./api";
import { t } from "./i18n";

const TG_ICON = `<svg viewBox="0 0 240 240" fill="currentColor" aria-hidden="true"><path d="M120 0C53.7 0 0 53.7 0 120s53.7 120 120 120 120-53.7 120-120S186.3 0 120 0zm55.8 82.3l-18.6 87.7c-1.4 6.2-5.1 7.7-10.3 4.8l-28.5-21-13.7 13.2c-1.5 1.5-2.8 2.8-5.7 2.8l2-28.9 52.8-47.7c2.3-2-.5-3.2-3.6-1.2l-65.3 41.1-28.1-8.8c-6.1-1.9-6.2-6.1 1.3-9l109.9-42.4c5.1-1.9 9.6 1.2 7.8 8.4z"/></svg>`;

export async function renderLogin(el: HTMLElement, onSuccess: () => Promise<void>): Promise<void> {
  el.innerHTML = `<div class="card login-card"><p class="hint">${t("login.creating")}</p></div>`;
  let init: { state: string; login_url: string };
  try {
    init = await api.authInit();
  } catch (e: any) {
    el.innerHTML = `<div class="card login-card empty">${t("login.error", { msg: e.message })}</div>`;
    return;
  }
  el.innerHTML = `
    <div class="card login-card">
      <h2>${t("login.title")}</h2>
      <p>${t("login.subtitle")}</p>
      <a class="btn" target="_blank" rel="noopener" href="${init.login_url}">${TG_ICON} ${t("login.open_tg")}</a>
      <p id="login-status">${t("login.waiting")}</p>
    </div>
  `;
  const status = el.querySelector<HTMLElement>("#login-status")!;
  const start = Date.now();
  while (Date.now() - start < 10 * 60_000) {
    await new Promise(r => setTimeout(r, 2000));
    try {
      const r = await api.authCheck(init.state);
      if (r.status === "ok" && r.session_token) {
        setToken(r.session_token);
        status.textContent = t("pay.success").replace("✓ ", "✅ ");
        await onSuccess();
        location.hash = "#/chat";
        return;
      }
      if (r.status === "expired") {
        status.textContent = t("login.expired");
        return;
      }
    } catch {
      // retry
    }
  }
  status.textContent = t("login.timeout");
}
